import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

export function SellerAbout() {
    const params = useParams();
    const { sellerCode } = params;
    return <Box>Seller About {sellerCode}</Box>
}